// extracted by mini-css-extract-plugin
export var layoutContainer = "_dx-0";
export var layoutContainerNoRounding = "_dx-6";
export var layoutContainerOpen = "_dx-5";
export var layoutContainerResizing = "_dx-1";
export var mainContent = "_dx-2";
export var resizeDivider = "_dx-3";
export var slidePanel = "_dx-4";